import { render } from "./ErrorLogin.vue?vue&type=template&id=6959a3da&scoped=true"
import script from "./ErrorLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorLogin.vue?vue&type=script&setup=true&lang=js"

import "./ErrorLogin.vue?vue&type=style&index=0&id=6959a3da&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6959a3da"],['__file',"src/components/UI/errors/ErrorLogin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6959a3da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6959a3da', __exports__)) {
    api.reload('6959a3da', __exports__)
  }
  
  module.hot.accept("./ErrorLogin.vue?vue&type=template&id=6959a3da&scoped=true", () => {
    api.rerender('6959a3da', render)
  })

}


export default __exports__